import { render, staticRenderFns } from "./PullBackPolicy.vue?vue&type=template&id=900642f6&scoped=true&"
import script from "./PullBackPolicy.vue?vue&type=script&lang=js&"
export * from "./PullBackPolicy.vue?vue&type=script&lang=js&"
import style0 from "./PullBackPolicy.vue?vue&type=style&index=0&id=900642f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900642f6",
  null
  
)

export default component.exports